import React, { useEffect, useState } from "react";
import { useAuth } from "../../provider/AuthProvider";
import pointAPI from "../../api/pointAPI";
import MasterPage from "../../layouts/MasterPage";
import { useNavigate } from "react-router";
import AuthenticationManager from "../../services/StorageJWT";

const Points = () => {
    // const [point,setPoint]=useState(0)
    const _auth= new AuthenticationManager();
    const navigate=useNavigate();
    // useEffect(() => {
    //     pointAPI.point(token)
    //     .then(res=>setPoint(res))
  
    //   }, []);
  return (
    <MasterPage>
    <div className="structure-page-3 structure-page-5 login p-3 body points ">
      <div className="p-2 content ">
  
      <div className="mt-5">
        <p>مجموع امتیاز شما:</p>
        <h3 className=" profile-point">
          {_auth._token.point} <br />
          امتیاز
        </h3>
      </div>
      <div className=" mt-5 ">
        <h6>
         از چه راه‌هایی می‌توانیم امتیاز خود را افزایش دهیم؟
        </h6>
      <p>شما میتوانید از راه های مختلفی امتیاز کسب کنید. 
        <br />
        در حال حاضر با ثبت مشخصات هرهم بازی خود 200 امتیاز دریافت خواهید کرد.
        </p>
      </div>
    </div>
    <div className="add-player" role="button"
          onClick={() =>navigate("/menu/assist",{state:{prePage:"menu"}})} 
        
        >
           <span><img src="/icons/share.svg" className="pe-2" alt="" /></span>
         <span>ثبت مشخصات همبازی‌ها </span>
        
        </div>
    <button
          onClick={() => navigate(-1)} 
          className="btn btn-return pt-2 pb-2 w-100"
        >
          بازگشت
        </button>
    </div>
    </MasterPage>
  );
};

export default Points;
